import { Outlet } from 'react-router';

export function SkipRoute() {
  return <Outlet />;
}
